import styled from "styled-components";

export const Inner = styled.div`
	display: flex;
	${(props) => props.isUserSeller && `padding: 20px 30px;`}
`;
